export var SENSITIVE_STRING = "***SensitiveInformation***";